import ProductDEECTable1 from "@/Config/Export/CreateNewJob/ProductJsons/ProductDEECTable1";
import ProductDEECTable2 from "@/Config/Export/CreateNewJob/ProductJsons/ProductDEECTable2";
import ProductEPCGTable1 from "@/Config/Export/CreateNewJob/ProductJsons/ProductEPCGTable1";
import ProductEPCGTable2 from "@/Config/Export/CreateNewJob/ProductJsons/ProductEPCGTable2";
import ProductDFIATable1 from "@/Config/Export/CreateNewJob/ProductJsons/ProductDFIATable1";
import ProductDFIATable2 from "@/Config/Export/CreateNewJob/ProductJsons/ProductDFIATable2";

export const schemaMap = {
  deecItem: ProductDEECTable2,
  deec: ProductDEECTable1,
  exportProductEPCG : ProductEPCGTable1,
  exportProductEPCGItem : ProductEPCGTable2,
  exportProductDFIA: ProductDFIATable1,
  exportProductDFIAItem: ProductDFIATable2
};